export const colors = {
  DARK_GREEN: '#136067',
  DARK_RED: '#D6241B'
};

export const Theme = {
  primary: colors.DARK_RED,
  secondary: colors.DARK_GREEN
};
